import { render, staticRenderFns } from "./NaviCompact.vue?vue&type=template&id=f47b6910&scoped=true"
import script from "./NaviCompact.vue?vue&type=script&lang=js"
export * from "./NaviCompact.vue?vue&type=script&lang=js"
import style0 from "./NaviCompact.vue?vue&type=style&index=0&id=f47b6910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b6910",
  null
  
)

export default component.exports